/**
 * Regex-based PII scrubber.
 * Detects and redacts common PII patterns: email, phone, SSN, credit card, IP.
 */

interface ScrubPattern {
  pattern: RegExp;
  replacement: string;
}

const PII_PATTERNS: ScrubPattern[] = [
  // SSN must come before phone to avoid partial matches
  { pattern: /\b\d{3}-\d{2}-\d{4}\b/g, replacement: '[SSN]' },
  // Credit card (4 groups of 4 digits, optional separators)
  { pattern: /\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g, replacement: '[CARD]' },
  // Email
  { pattern: /\b[\w.+-]+@[\w.-]+\.\w+\b/g, replacement: '[EMAIL]' },
  // AU/International phone: +61 4xx xxx xxx, 04xx xxx xxx, 02 xxxx xxxx
  // Must come before TFN to avoid partial digit group matches inside phone numbers
  { pattern: /(?:\+61[\s.-]?|0)[2-9](?:[\s.-]?\d){8}\b/g, replacement: '[PHONE]' },
  // AU Tax File Number: NNN NNN NNN
  { pattern: /\b\d{3}\s\d{3}\s\d{3}\b/g, replacement: '[TFN]' },
  // Phone (various formats: 123-456-7890, 123.456.7890, 1234567890, (123) 456-7890)
  { pattern: /\b\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}\b/g, replacement: '[PHONE]' },
  // IPv4
  { pattern: /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g, replacement: '[IP]' },
];

/**
 * Scrub PII from text using regex patterns.
 * Order matters: SSN before phone (to avoid partial overlap), credit card early.
 */
export function regexScrub(text: string): string {
  let scrubbed = text;
  for (const { pattern, replacement } of PII_PATTERNS) {
    // Reset lastIndex for global regexes used across multiple calls
    pattern.lastIndex = 0;
    scrubbed = scrubbed.replace(pattern, replacement);
  }
  return scrubbed;
}
